<h2 mat-dialog-title>{{'DIALOG_TITLE' | translate}}</h2>
<mat-dialog-content>
  <p>{{text}}</p>
</mat-dialog-content>
<mat-dialog-actions class="dialog-button-area">
  <button  class="no-button" (click)="close()" mat-raised-button>{{'DIALOG_NO' | translate}}</button>
  <button  class="ok-button" (click)="back()" mat-raised-button>{{'DIALOG_YES' | translate}}</button>
</mat-dialog-actions>

